import { Users } from "../sdk";
import { IRoles } from "./iRoles";
import { ICompany } from "./iCompany";

export class IUsers extends Users {

    public static readonly FIELDS: Array<string> = ['id', 'name', 'company_id', 'login', 'groups_id', 'wcp_location'];
    public static readonly FILTER_INCLUDE:any = [
        {
            "relation": "groups",
            "scope": {
                "fields": ["id", "name", "full_name", "category_id"],
                "include":[
                    {
                        "relation": "categories",
                        "scope": {
                            "fields": ["id", "name"],
                            "where": {
                                "name": "Residue Management"
                            }
                        }
                    }
                ]
            }
        },
        {
            "relation": "wcpLocation",
            "scope": {
                "fields": ["id", "name", "warehouse_id"],
                "include": [
                    {
                        "relation": "warehouse",
                        "scope": {
                            "fields": ["id", "name", "wh_input_stock_loc_id", "wh_qc_stock_loc_id", "wh_pack_stock_loc_id", "wh_output_stock_loc_id", "sam_stock_loc_id", "pbm_stock_loc_id"],
                            "include": [
                                {
                                    "relation": "whInput",
                                    "scope": {"fields": ["id", "name"]}
                                },
                                {
                                    "relation": "whQc",
                                    "scope": {"fields": ["id", "name"]}
                                },
                                {
                                    "relation": "whPack",
                                    "scope": {"fields": ["id", "name"]}
                                },
                                {
                                    "relation": "whOutput",
                                    "scope": {"fields": ["id", "name"]}
                                },
                                {
                                    "relation": "whSam",
                                    "scope": {"fields": ["id", "name"]}
                                },
                                {
                                    "relation": "whPbm",
                                    "scope": {"fields": ["id", "name"]}
                                }
                            ]
                        }
                    },
                ]
            }
        }
    ];

    //roles del usuario
    public roles:IRoles;

    //mi compañia seleccionada
    public myCompany:ICompany;

    constructor(json: Users) {
        super(json);

        //inicializamos roles
        this.roles = new IRoles(json);
    }

}


// WEBPACK FOOTER //
// ./src/models/iUsers.ts